var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"modalMenuImg"}},[_c('div',{staticClass:"img",style:(`background-image: url('${_vm.img}');`)},[_c('div',{staticClass:"container_icon"},[_c('i',{staticClass:"fa fa-times close",attrs:{"aria-hidden":"true"},on:{"click":function($event){return _vm.$parent.close()}}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }